import React from 'react';

class RepeaterCard extends React.Component {
  render() {
    const { title, subtitle, onRemove, removable, children, badge } = this.props;
    return (
      <div className="rounded-2xl border border-[#E5E7EB] bg-[#F9FAFB] p-4 sm:p-5 mb-4 shadow-sm">
        <div className="flex items-start justify-between gap-3 mb-4 pb-3 border-b border-[#E5E7EB]">
          <div className="min-w-0">
            <div className="flex items-center gap-2 flex-wrap">
              <h4 className="text-sm sm:text-base font-semibold text-[#1F2937]">{title}</h4>
              {badge ? (
                <span
                  className="inline-flex items-center rounded-full px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide"
                  style={{ backgroundColor: '#EFEAFE', color: '#5B3FE0' }}
                >
                  {badge}
                </span>
              ) : null}
            </div>
            {subtitle ? (
              <p className="mt-0.5 text-xs text-[#6B7280] truncate">{subtitle}</p>
            ) : null}
          </div>
          {removable !== false && onRemove ? (
            <button
              type="button"
              onClick={onRemove}
              className="text-xs font-semibold text-[#DC2626] hover:underline whitespace-nowrap"
            >
              Remove
            </button>
          ) : null}
        </div>
        <div className="space-y-4">
          {children}
        </div>
      </div>
    );
  }
}

export default RepeaterCard;
